import useGetMyRegionPreferences from '@/api/queries/me/useGetMyRegionPreferences';
import useGetTask from '@/api/queries/tasks/useGetTask';
import { ViewFieldset, Text } from '@payaca/ambrosia';

import useGetMyAccountUsersIncludeDeactivated from '@/api/queries/me/useGetMyAccountUsersIncludeDeactivated';
import { CustomFieldDefinition } from '@payaca/custom-fields';
import { CustomFieldReadonlyGroup } from '@payaca/custom-fields-react';
import {
  DateFormats,
  getInternationalDateFormatByLocale,
} from '@payaca/helpers/internationalHelper';
import { Task } from '@payaca/types/taskTypes';
import { format } from 'date-fns';
import { FC } from 'react';

export type TProps = {
  taskId: Task['id'];
};

const CustomFieldTaskView: FC<TProps> = (props) => {
  const { taskId } = props;

  const { data: taskData } = useGetTask(taskId);
  const { data: users } = useGetMyAccountUsersIncludeDeactivated();

  if (!taskData || taskData?.task?.__typename !== 'CustomFieldsTask') {
    return null;
  }

  if (!taskData.task.completedAt) {
    return <Text>Task has not been completed by field agent</Text>;
  }

  return (
    <>
      <ViewFieldset>
        {taskData.task.customFields.map((fieldset) => {
          const value = JSON.parse(fieldset.value || '{}');
          const definition = CustomFieldDefinition.fromSchema(
            fieldset.field.schema
          );

          if (definition.type !== 'fieldset') {
            return <></>;
          }

          return (
            <CustomFieldReadonlyGroup
              key={definition.identifier}
              definitions={definition.children}
              value={value}
              users={users}
            />
          );
        })}
      </ViewFieldset>

      <div className="border-t mt-3 pt-6 pb-4">
        <Text>
          Completed on:{' '}
          {format(
            taskData.task.completedAt,
            getInternationalDateFormatByLocale(DateFormats.TIMESTAMP)
          )}
        </Text>
      </div>
    </>
  );
};

export default CustomFieldTaskView;
